import { useMemo } from 'react';
import { Tags } from '@eventbrite/legacy-infra.tags';
import { useIntl } from 'react-intl';
import { useAppSelector } from '@/redux/hooks';
import { selectTTDShelf } from '@/redux/thingsToDoShelf';
import type { TagObject } from '@eventbrite/legacy-infra.tags/types';
import styles from './ThingsToDoShelfContainer.module.scss';

export const ThingsToDoShelfContainer = ({
    languageSubdirectory,
}: {
    languageSubdirectory?: string;
}) => {
    const { header, tags } = useAppSelector(selectTTDShelf);
    const localePath = languageSubdirectory ? '/' + languageSubdirectory : '';
    const intl = useIntl();

    const shelfHeader = useMemo(
        () => ({
            title: intl.formatMessage(
                {
                    id: 'Things to do around {geo}',
                    defaultMessage: 'Things to do around {geo}',
                },
                { geo: header.placeName },
            ),
            url: `${localePath}${header.url}`,
        }),
        [header.placeName, header.url, intl],
    );

    const shelfTags: TagObject[] = useMemo(
        () =>
            tags.map((tag) => {
                return {
                    displayText: String(
                        intl.formatMessage(
                            {
                                id: 'Things to do in {geo}',
                                defaultMessage: 'Things to do in {geo}',
                            },
                            { geo: tag.placeName },
                        ),
                    ),

                    linkUrl: `${tag.linkUrl.split('/ttd/')[0]}${localePath}/ttd/${
                        tag.linkUrl.split('/ttd/')[1]
                    }`,
                };
            }),
        [tags, intl, localePath],
    );

    if (!tags || !tags.length) {
        return null;
    }

    return (
        <div className={styles.root}>
            {header.url ? (
                <a className={styles.link} href={header.url}>
                    <h2 className={styles.header}>{shelfHeader.title}</h2>
                </a>
            ) : (
                <h2 className={styles.header}>{shelfHeader.title}</h2>
            )}

            <Tags tags={shelfTags} />
        </div>
    );
};
